import { getNotificationById } from "@/services";
import { NOTIFICATION_QUERY_KEYS } from "@/types";
import { useQuery } from "@tanstack/react-query";

export function useGetNotificationDetail(notificationId: number | null) {
  const { data, isLoading, error, isFetched } = useQuery({
    queryKey: [NOTIFICATION_QUERY_KEYS.NOTIFICATION_BY_ID, notificationId],
    queryFn: () => getNotificationById(notificationId as unknown as number),
    enabled: !!notificationId,
  });

  return { notification: data?.data, isLoading, error, isFetched };
}
